<template>
    <div>
        <div class="btn">
            <a href="javascript:;" @click="downBtn" class="actSignIn_btn">功能按钮</a>
        </div>
    </div>
</template>
<script>
export default {
	name: 'pc-downBtn',
	actConfig: {
		labels: { // 字段名称，用于显示在配置系统上，在正式环境会删除
			modulesTitle: '头部文案：',
			bgImg: '背景图片',
			modulesRules: '规则描述：',
			tabItems: 'Tab',
			name: '名称',
			image: '图片',
			action: '动作',
			actionType: '动作类型', // 自定义动作类型，系统内置有 ams: ams动作， link: 跳转到外链
			buttonName: '按钮文案',
		},
	},
	props: {
		buttonName: {
			type: String,
			default: '功能按钮',
			label: '按钮',
		},
		downtList: {
			type: Array,
			default: function () {
				return [
					{
						title: '立即下载',
					},
					{
						title: '下载中',
					},
					{
						title: '安装',
					},
					{
						title: '启动',
					},
				]
			}
		}
	},
	data () {
		return {

		}
	},
	methods: {
		downBtn () {

		}
	}
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/common';
.btn {
    position: fixed;
    bottom: 0;
    left: 50%;
}
.actSignIn_btn {
  width: 230px;
  height: 70px;
  line-height: 70px;
  font-size: 28px;
  color: #4a4a4a;
  @extend %block;
  text-align: center;
  background: #e27f7f;
  margin: 40px auto 0;
}
</style>



// WEBPACK FOOTER //
// src/components/actModules/pc/templates/bottomBtn/downBtn.vue